import React from 'react';

import Table from './Table';
import TableHead from './TableHead';
import TableRow from './TableRow';
import TableCell from './TableCell';
import TableBody from './TableBody';
import TableFoot from './TableFoot';

import { REPORTS_TABLES_COLUMNS } from '../../constants/ReportsTablesColumns';

import { ReportTableType } from '../../types/ReportTableType';

interface LotsReportTableProps {
    reportType: ReportTableType;
    headerTableData?: { key: string; title: string; minWidth: number; maxWidth: number }[];
    bodyTableData: Record<string, any>[];
    footerTableData?: number;
}

const LotsReportTable: React.FC<LotsReportTableProps> = (props) => {
    const { reportType, bodyTableData } = props;

    const [lotsTotalSum, setLotsTotalSum] = React.useState<number>(0);

    React.useEffect(() => {
        if (bodyTableData && bodyTableData.length > 0) {
            let totalSum = 0;
            bodyTableData.forEach((lot) => {
                totalSum += lot.lotTotalExclVat;
            });
            setLotsTotalSum(totalSum);
        }
    }, [bodyTableData]);

    return (
        <Table additionalClasses="is-striped is-hoverable is-fullwidth">
            <TableHead>
                <TableRow>
                    {REPORTS_TABLES_COLUMNS[reportType].map((column) => (
                        <TableCell
                            key={column.key}
                            type="head"
                            draggable={false}
                            additionalClasses={column.additionalClasses}
                        >
                            <div className="th-wrap is-relative">{column.title}</div>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>

            {bodyTableData && bodyTableData.length > 0 ? (
                <React.Fragment>
                    <TableBody>
                        {bodyTableData.map((row) => (
                            <TableRow key={row.lotId}>
                                <TableCell type="body" draggable={false}>
                                    {row.lotCode}
                                </TableCell>
                                <TableCell type="body" draggable={false}>
                                    {row.lotTitle}
                                </TableCell>
                                <TableCell type="body" draggable={false} additionalClasses="has-text-right">
                                    {row.lotTotalExclVat.toLocaleString('fr-FR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}{' '}
                                    €
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>

                    <TableFoot>
                        <TableRow additionalClasses="table-footer has-background-light">
                            <TableCell type="foot" additionalClasses="is-hidden-mobile">
                                <div className="th-wrap is-numeric">{null}</div>
                            </TableCell>
                            <TableCell type="foot" additionalClasses="is-hidden-mobile">
                                <div className="th-wrap">Total</div>
                            </TableCell>
                            <TableCell type="foot" additionalClasses="has-text-right">
                                <div>
                                    {lotsTotalSum?.toLocaleString('fr-FR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}{' '}
                                    €
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableFoot>
                </React.Fragment>
            ) : null}
        </Table>
    );

    // if (reportType === 'classification-report') {
    //     return (
    //         <Table additionalClasses="is-striped is-hoverable is-fullwidth">
    //             <TableHead>
    //                 <TableRow>
    //                     {REPORTS_TABLES_COLUMNS[reportType].map((column) => (
    //                         <TableCell
    //                             key={column.key}
    //                             type="head"
    //                             draggable={false}
    //                             additionalClasses="is-sortable is-unselectable"
    //                         >
    //                             <div className="th-wrap is-relative">{column.title}</div>
    //                         </TableCell>
    //                     ))}
    //                 </TableRow>
    //             </TableHead>
    //         </Table>
    //     );
    // }

    // if (reportType === 'nodes-by-category-and-location-report') {
    //     return (
    //         <Table additionalClasses="is-striped is-hoverable is-fullwidth">
    //             <TableHead>
    //                 <TableRow>
    //                     {REPORTS_TABLES_COLUMNS[reportType].map((column) => (
    //                         <TableCell
    //                             key={column.key}
    //                             type="head"
    //                             draggable={false}
    //                             additionalClasses="is-sortable is-unselectable"
    //                         >
    //                             <div className="th-wrap is-relative">{column.title}</div>
    //                         </TableCell>
    //                     ))}
    //                 </TableRow>
    //             </TableHead>
    //         </Table>
    //     );
    // }
};

export default LotsReportTable;
